import type { PublicSlotKey } from '@/apilib';
import type { WorkspaceApi } from './api';

export const WorkspaceApiKey: PublicSlotKey<WorkspaceApi> = {
  name: 'Workspace API',
  public: true,
};
